module.exports = __webpack_public_path__ + "media/images/lb/829-35dc2a7c3e8bc7300e976991c8491f6e.svg";